import { useEffect } from "react";

import envVariables from "../projectEnvVariables";

declare global {
  interface Window {
    _walkmeConfig?: { smartLoad: boolean };
  }
}

// The env module is untyped .js; read it through `unknown` plus a guard.
const env: unknown = envVariables;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const rawWalkMeSrc = isRecord(env) ? env.VITE_REACT_APP_WALK_ME_SRC : undefined;
const walkMeSrc = typeof rawWalkMeSrc === "string" ? rawWalkMeSrc : "";

const useWalkMe = (): void => {
  useEffect(() => {
    if (walkMeSrc) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = walkMeSrc;
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(script, s);

      window._walkmeConfig = { smartLoad: true };

      return () => {
        s.parentNode.removeChild(script);
      };
    }
  }, []);
};

export default useWalkMe;
